import {mainQuery} from '@github-ui/react-core/future/main-query'
import {issuesAppBuilder} from '../config/app-builder'

export type IssuesLayoutPayload = {
  has_projects_enabled: boolean
  // Server-read seed of the sidebar collapse cookie; null when disabled. Passed
  // as `initialExpanded` so a collapsed sidebar doesn't flash open on SSR.
  sidebar_expanded?: boolean | null
}

export const issuesLayoutRoute = issuesAppBuilder.createQueryRouteConfig('issuesLayoutRoute', {
  path: '/:owner/:repo',
  queries: [
    mainQuery<IssuesLayoutPayload>({
      // fetches shared layout data (e.g. sidebar config) from a dedicated endpoint,
      // cached and reused across all child routes (e.g. labels, milestones...)
      queryDeps: ({pathname}) => {
        // comma in the beginning to omit the empty string result of split before the first slash
        const [, owner, repo] = pathname.split('/')
        return {pathname: `/${owner}/${repo}/issues/_layout`}
      },
      staleTimeForNavigation: 360000,
    }),
  ],
})
